//
//
//
//
//
//
//
//
//
//
//
//
//

import productCouponList from '../index.vue';
export default {
  name: 'ProductCouponFrom',
  components: {
    productCouponList: productCouponList
  },
  data: function data() {
    return {
      visible: false,
      callback: function callback() {},
      useType: 1
    };
  },
  watch: {
    // show() {
    //   this.visible = this.show
    // }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.visible = false;
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    getProductCouponId: function getProductCouponId(couponObj) {
      this.callback(couponObj);
      this.visible = false;
    }
  }
};